import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tiposBoletins: [
      { id: 'bg',       nome: 'Boletim Geral',             sigla: 'BG'       , resource: 'boletins_gerais' },
      { id: 'br',       nome: 'Boletim Reservado',         sigla: 'BR'       , resource: 'boletins_reservados' },
      { id: 'bi-1gbm',  nome: 'Boletim Interno 1º GBM',    sigla: 'BI 1º GBM', resource: 'boletins_internos_1gbm' },
      { id: 'bi-2gbm',  nome: 'Boletim Interno 2º GBM',    sigla: 'BI 2º GBM', resource: 'boletins_internos_2gbm' },
      { id: 'bi-3gbm',  nome: 'Boletim Interno 3º GBM',    sigla: 'BI 3º GBM', resource: 'boletins_internos_3gbm' },
      { id: 'bi-4gbm',  nome: 'Boletim Interno 4º GBM',    sigla: 'BI 4º GBM', resource: 'boletins_internos_4gbm' },
      { id: 'bi-5gbm',  nome: 'Boletim Interno 5º GBM',    sigla: 'BI 5º GBM', resource: 'boletins_internos_5gbm' },
      { id: 'bi-6gbm',  nome: 'Boletim Interno 6º GBM',    sigla: 'BI 6º GBM', resource: 'boletins_internos_6gbm' },
      { id: 'bi-7gbm',  nome: 'Boletim Interno 7º GBM',    sigla: 'BI 7º GBM', resource: 'boletins_internos_7gbm' },
      { id: 'bi-8gbm',  nome: 'Boletim Interno 8º GBM',    sigla: 'BI 8º GBM', resource: 'boletins_internos_8gbm' },
      { id: 'bi-gpcif', nome: 'Boletim Interno GPCIF',     sigla: 'BI GPCIF' , resource: 'boletins_internos_gpcif' },
      { id: 'bi-gmaf',  nome: 'Boletim Interno GMAF',      sigla: 'BI GMAF'  , resource: 'boletins_internos_gmaf' },
      { id: 'bi-gaeph', nome: 'Boletim Interno GAEPH',     sigla: 'BI GAEPH' , resource: 'boletins_internos_gaeph' }
    ]
  },
  mutations: {

  },
  actions: {

  }
})
